import {Component, ViewChild, ElementRef} from '@angular/core';
import {IonicPage, AlertController, NavParams, ViewController, ModalController} from 'ionic-angular';
import {
    HomogenizationOrderInLineApi,
    PartnerApi, ProductApi,
    StockLocationApi, StockQuantPackage, StockQuantPackageApi,
    StockWarehouseLocationApi
} from "../../sdk";
import {HomogenizationOrder, HomogenizationOrderInLine} from '../../sdk';
import {BaseViewComponent} from '../../components/baseViewComponent';
import {LoadingComponent} from '../../components/loadingComponent';
import {LoopBackAuth} from "../../sdk";
import {ServerProvider} from "../../providers/server-provider";
import {IStockLocation} from "../../models/iStockLocation";
import {IProduct} from "../../models/iProduct";
import {IStockQuantPackage} from "../../models/iStockQuantPackage";

@IonicPage({
    segment: 'homogenization-order-inline-add',
    name: 'HomogenizationOrderInlineAddPage'
})
@Component({
    selector: 'page-homogenization-order-inline-add',
    templateUrl: 'homogenization-order-inline-add.html',
})
export class HomogenizationOrderInlineAddPage extends BaseViewComponent {

    @ViewChild('epcInput') epcInput: ElementRef;
    @ViewChild('noteTextArea') noteTextArea: ElementRef;

    public order: HomogenizationOrder;
    public createInLine: HomogenizationOrderInLine;
    public isOpenModal: boolean = false;
    public selectedPackage: string;
    public selectedEPC: string;

    constructor(
        public alertCtrl: AlertController,
        public params: NavParams,
        public homogenizationOrderInLineService: HomogenizationOrderInLineApi,
        public partnerService: PartnerApi,
        public viewCtrl: ViewController,
        public loading: LoadingComponent,
        public modalCtrl: ModalController,
        public authService: LoopBackAuth,
        public stockWarehouseLocationService: StockWarehouseLocationApi,
        public stockLocationService: StockLocationApi,
        public packageService: StockQuantPackageApi,
        public productService: ProductApi,
    ) {
        super();
        this.order = new HomogenizationOrder();
        this.createInLine = new HomogenizationOrderInLine();
        this.selectedPackage = ""
    }

    ionViewDidEnter() {
        if (this.epcInput && this.epcInput['setFocus']) {
            setTimeout(() => {
                this.epcInput['setFocus']();
            }, 300); // el delay ayuda a asegurar que esté lista la vista
        }
    }

    ionViewDidLoad() {
        super.ionViewDidLoad();
        this.order = this.params.get("order");
        this.setDefaults();
    }

    public setDefaults() {
        this.createInLine.homogenization_order_id = this.order.id
        this.createInLine.company = this.order.company
        this.createInLine.company_id = this.order.company_id
        this.createInLine.user = this.order.user
        this.createInLine.user_id = this.order.user_id
        this.createInLine.locationDest = this.order.productionLocation
        this.createInLine.location_dest_id = this.order.production_location_id
        this.createInLine.location_id = this.order.location_id
        this.createInLine.location = this.order.location
        delete this.createInLine.productUom
        delete this.createInLine.product_uom_id
        this.createInLine.product_qty = 0
        this.createInLine.state = 'draft'
    }

    public getState(): string {
        return this.createInLine.state
    }

    public selectState() {
        return
    }

    public getLocation(): string {
        if (this.createInLine.location) {
            return this.createInLine.location.name;
        }
        return "-";
    }

    public selectLocation() {
        this.loading.create({content: 'Cargando localizaciones', showBackdrop: false});
        ServerProvider.find(this.stockLocationService, {
            fields: IStockLocation.FIELDS,
            include: IStockLocation.FILTER_INCLUDE
        }, true).subscribe(locations => {
            if (locations && locations.length > 0) {
                this.loading.dismiss();
                let modal = this.modalCtrl.create('CustomSelectorPage', {
                    strSearchBar: this.createInLine.location ? this.createInLine.location.name : "",
                    listItems: locations
                });
                this.isOpenModal = true;
                modal.present();
                modal.onWillDismiss(data => {
                    if (data && data.name) {
                        this.createInLine.location = data;
                        this.createInLine.location_id = data.id;
                    }
                    this.isOpenModal = false;
                });
            } else {
                this.alertCtrl.create({
                    title: 'Error',
                    subTitle: 'No hay ninguna localización disponible',
                    buttons: ['Aceptar']
                }).present();
                this.loading.dismiss();
            }
        });

    }

    public getLocationDest(): string {
        if (this.createInLine.locationDest) {
            return this.createInLine.locationDest.name;
        }
        return "-";
    }

    public selectLocationDest() {
        return
    }

    public getPackage(): string {
        if (this.createInLine.package) {
            return this.createInLine.package.name
        }
        return ""
    }

    /*public selectPackage() {
        this.loading.create({content: 'Cargando paquetes', showBackdrop: false});
        ServerProvider.find(this.packageService, {
            fields: IStockQuantPackage.FIELDS,
            include: IStockQuantPackage.FILTER_INCLUDE,
            where: {
                location_id: this.order.location_id
            }
        }, true).subscribe(packages => {
            if (packages && packages.length > 0) {
                this.loading.dismiss();
                let modal = this.modalCtrl.create('CustomSelectorPage', {
                    strSearchBar: this.selectedPackage,
                    listItems: packages
                });
                this.isOpenModal = true;
                modal.present();
                modal.onWillDismiss(data => {
                    if (data && data.name) {
                        this.setPackage(data);
                    }
                    this.isOpenModal = false;
                });
            } else {
                this.alertCtrl.create({
                    title: 'Error',
                    subTitle: 'No hay ningún paquete disponible.',
                    buttons: ['Aceptar']
                }).present();
                this.loading.dismiss();
            }
        }, error => {
            console.log(error)
        });
    }*/
    public checkEpc() {
        if (this.selectedEPC && this.selectedEPC.length === 24) {
            this.loading.create({ content: 'Cargando paquetes', showBackdrop: false });

            let where: any = {
                location_id: this.order.location_id
            };

            if (this.selectedEPC && this.selectedEPC.length === 24) {
                where.epc_code = this.selectedEPC;
            }

            ServerProvider.find(this.packageService, {
                fields: IStockQuantPackage.FIELDS,
                include: IStockQuantPackage.FILTER_INCLUDE,
                where: where
            }, true).subscribe(packages => {
                if (packages && packages.length > 1) {
                    let modal = this.modalCtrl.create('CustomSelectorPage', {
                        strSearchBar: "",
                        listItems: packages
                    });
                    this.isOpenModal = true;
                    modal.present();
                    modal.onWillDismiss(data => {
                        if (data && data.name) {
                            this.setPackage(data);
                        }
                        this.isOpenModal = false;
                        this.loading.dismiss();
                    });
                } else if (packages && packages.length == 1) {
                    let _package: StockQuantPackage = packages[0];
                    this.setPackage(_package);
                    this.loading.dismiss();
                } else {
                    this.removePackageValues();
                    this.alertCtrl.create({
                        title: 'Error',
                        subTitle: 'No se han encontrado paquetes.',
                        buttons: ['Aceptar']
                    }).present();
                    this.loading.dismiss();
                }
            });
        }
    }

    public checkPackage() {
        if (this.selectedPackage !== "") {
            this.loading.create({ content: 'Cargando paquetes', showBackdrop: false });

            let where: any = {
                location_id: this.order.location_id
            };

            if (this.selectedPackage !== '') {
                where.name = { like: this.selectedPackage + "%" };
            }

            ServerProvider.find(this.packageService, {
                fields: IStockQuantPackage.FIELDS,
                include: IStockQuantPackage.FILTER_INCLUDE,
                where: where
            }, true).subscribe(packages => {
                if (packages && packages.length > 1) {
                    let modal = this.modalCtrl.create('CustomSelectorPage', {
                        strSearchBar: "",
                        listItems: packages
                    });
                    this.isOpenModal = true;
                    modal.present();
                    modal.onWillDismiss(data => {
                        if (data && data.name) {
                            this.setPackage(data);
                        }
                        this.isOpenModal = false;
                        this.loading.dismiss();
                    });
                } else if (packages && packages.length == 1) {
                    let _package: StockQuantPackage = packages[0];
                    this.setPackage(_package);
                    this.loading.dismiss();
                } else {
                    this.removePackageValues();
                    this.alertCtrl.create({
                        title: 'Error',
                        subTitle: 'No se han encontrado paquetes.',
                        buttons: ['Aceptar']
                    }).present();
                    this.loading.dismiss();
                }
            });
        } else {
            this.alertCtrl.create({
                title: 'Error',
                subTitle: 'Introduce algún carácter para buscar.',
                buttons: ['Aceptar']
            }).present();
            this.removePackageValues();
        }
    }


    public setPackage(_package: StockQuantPackage) {
        this.selectedPackage = _package.name;

        this.selectedEPC = _package.epc_code;
        this.createInLine.package = _package;
        this.createInLine.package_id = _package.id;
        if (_package.quant_ids.length > 0 && _package.quants[0].product) {
            this.createInLine.product = _package.quants[0].product
            this.createInLine.product_id = _package.quants[0].product_id
            this.createInLine.productUom = _package.quants[0].productUom
            this.createInLine.product_uom_id = _package.quants[0].product_uom_id
            this.createInLine.prodLot = _package.quants[0].lot
            this.createInLine.prod_lot_id = _package.quants[0].lot_id
            let totalQty = 0;
            _package.quants.forEach((quant) => {
                totalQty += quant.quantity
            });
            this.createInLine.product_qty = totalQty
        } else {
            this.alertCtrl.create({
                title: 'Error',
                subTitle: 'Este paquete no tiene productos disponibles para asignar. Escoge otro.',
                buttons: ['Aceptar']
            }).present();
            this.selectedPackage = ""
            this.removePackageValues()
        }
    }

    public removePackageValues() {
        delete this.createInLine.package
        delete this.createInLine.package_id
        delete this.createInLine.product
        delete this.createInLine.product_id
        delete this.createInLine.productUom
        delete this.createInLine.product_uom_id
        delete this.createInLine.prodLot
        delete this.createInLine.prod_lot_id
        delete this.createInLine.product_qty
    }

    public getProdLot(): string {
        if (this.createInLine.prodLot) {
            return this.createInLine.prodLot.name;
        }
        return "-";
    }

    public selectProdLot() {
        return
    }

    public getProduct(): string {
        if (this.createInLine.product) {
            return this.createInLine.product.name;
        }
        return "-";
    }

    public selectProduct(): void {
        if (!this.isOpenModal) {
            this.loading.create({content: 'Cargando productos', showBackdrop: false});
            ServerProvider.find(this.productService, {
                fields: IProduct.FIELDS,
                include: IProduct.FILTER_INCLUDE
            }, true).subscribe(products => {
                if (products && products.length > 0) {
                    this.loading.dismiss();
                    let modal = this.modalCtrl.create('CustomSelectorPage', {
                        strSearchBar: "",
                        listItems: products
                    });
                    this.isOpenModal = true;
                    modal.present();
                    modal.onWillDismiss(data => {
                        if (data && data.name) {
                            this.createInLine.product = data;
                            this.createInLine.product_id = data.id;
                            this.createInLine.productUom = data.uom
                            this.createInLine.product_uom_id = data.uom_id
                        }
                        this.isOpenModal = false;
                    });
                } else {
                    this.alertCtrl.create({
                        title: 'Error',
                        subTitle: 'No hay ningún producto disponible',
                        buttons: ['Aceptar']
                    }).present();
                    this.loading.dismiss();
                }
            });
        }
    }

    public getProductUOMName(): String {
        if (this.createInLine && this.createInLine.product && this.createInLine.productUom) {
            return this.createInLine.productUom.name;
        }
        return "-";
    }

    public create() {
        if (this.createInLine.package_id && this.createInLine.product_id && this.createInLine.prod_lot_id) {
            this.loading.create({content: 'Creando', showBackdrop: false});
            ServerProvider.createOrUpdate(this.homogenizationOrderInLineService, this.createInLine).subscribe(success => {
                if (success) {
                    this.createInLine.id = success.id
                    this.loading.dismiss();
                    this.dismiss(true);
                }
            })
        } else {
            this.alertCtrl.create({
                title: 'Error',
                subTitle: 'Rellena todos los campos.',
                buttons: ['Aceptar']
            }).present();
        }
    }

    public createAndNew() {
        if (this.createInLine.package_id && this.createInLine.product_id && this.createInLine.prod_lot_id) {
            this.loading.create({content: 'Creando', showBackdrop: false});
            ServerProvider.createOrUpdate(this.homogenizationOrderInLineService, this.createInLine).subscribe(success => {
                if (success) {
                    this.createInLine.id = success.id
                    this.loading.dismiss();
                    this.dismiss({
                        reload: true,
                        new: true
                    });
                }
            })
        } else {
            this.alertCtrl.create({
                title: 'Error',
                subTitle: 'Rellena todos los campos.',
                buttons: ['Aceptar']
            }).present();
        }
    }

    public createAndProcess() {
        if (this.createInLine.package_id && this.createInLine.product_id && this.createInLine.prod_lot_id) {
            this.loading.create({content: 'Creando y procesando', showBackdrop: false});
            ServerProvider.createOrUpdate(this.homogenizationOrderInLineService, this.createInLine).subscribe(success => {
                if (success) {
                    this.createInLine.id = success.id
                    this.homogenizationOrderInLineService.process(this.createInLine.id, ServerProvider.getCustomHeaders).subscribe(success => {
                        this.loading.dismiss();
                        this.dismiss(true);
                    }, error => {
                        this.loading.dismiss();
                        this.dismiss(true);
                    })
                }
            })
        } else {
            this.alertCtrl.create({
                title: 'Error',
                subTitle: 'Rellena todos los campos.',
                buttons: ['Aceptar']
            }).present();
        }
    }

    public dismiss(data = null) {
        this.viewCtrl.dismiss(data)
    }

    public resizeTextArea(event) {
        if (event && event.keyCode == 13) {
            var element = this.noteTextArea['_elementRef'].nativeElement.getElementsByClassName("text-input")[0];
            var scrollHeight = element.scrollHeight;
            element.style.height = scrollHeight + 'px';
            this.noteTextArea['_elementRef'].nativeElement.style.height = (scrollHeight + 16) + 'px';
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/homogenization-order-inline-add/homogenization-order-inline-add.ts